import { render, staticRenderFns } from "./DuplicateOrderButton.vue?vue&type=template&id=79a79259&"
import script from "./DuplicateOrderButton.vue?vue&type=script&lang=js&"
export * from "./DuplicateOrderButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports